import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { css } from "@emotion/css";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import UploadIcon from "src/images/Icons/newIcons/upload.svg";

import { isTablet } from "../../helpers/isMobile";
import { getAppConfig } from "../../hooks/useAppConfig";
import { OutlinedPrimaryButton } from "../Default/LekUI/Button";
import { Loading } from "../TextEditor";

export function humanFileSize(size) {
	const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
	return `${+(size / 1024 ** i).toFixed(2) * 1} ${
		["B", "kB", "MB", "GB", "TB"][i]
	}`;
}

export function ImageFileUploader({ onAccept }) {
	const [loading, setLoading] = useState(false);
	const appConfig = getAppConfig();
	const { t } = useTranslation();
	const maxMB = appConfig.maxImageSizeMb;

	const runCameraUpload = async (source) => {
		let imagePath;
		setLoading(true);
		try {
			const image = await Camera.getPhoto({
				quality: 100,
				allowEditing: true,
				resultType: CameraResultType.Uri,
				correctOrientation: true,
				webUseInput: true,
				source,
			});
			imagePath = image.webPath;
		} catch {
			setLoading(false);
			return;
		}

		try {
			const response = await fetch(imagePath);
			const blob = await response.blob();

			const fileName = imagePath.split("/").pop() || String(Date.now());

			onAccept({ file: blob, name: fileName });
			setLoading(false);
		} catch {
			toast.error(t("errors.uploadImageProblem"), {
				position: toast.POSITION.BOTTOM_LEFT,
				pauseOnHover: false,
				autoClose: 3000,
			});
		}
	};

	return (
		<>
			<Loading isLoading={loading}>
				<div className="upload--file">
					<UploadIcon className="icon-huge primary-text-btn " />
					<OutlinedPrimaryButton
						className={css`
              width: 140px;
            `}
						onClick={() => runCameraUpload(CameraSource.Photos)}
					>
						{t("uploader.chooseFile")}
					</OutlinedPrimaryButton>
					{isTablet() && (
						<OutlinedPrimaryButton
							onClick={() => runCameraUpload(CameraSource.Camera)}
							className={css`
                width: 140px;
              `}
						>
							{t("uploader.takePhoto")}
						</OutlinedPrimaryButton>
					)}
				</div>
			</Loading>
			<span className="size-14-light text-grey mt-8">
				<Trans
					i18nKey="uploader.imageFormatsInfo"
					values={{ maxMB }}
					components={[<strong key="upload" />]}
				/>
			</span>
		</>
	);
}
